import { handleResponse } from '../../utils/handle-response';
import * as apiHelper from '../../utils/apiHelper';

export function getAllRegistrations() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLREGISTRATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function GetMaterials() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLMATERIALS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
export function GetWastestreams() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLWASTESTREAMS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
export function getUser(userid) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETUSER);
    url += `?userid=${userid}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
export function GetUnitOfMeasurements() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLUNITOFMEASUREMENTS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function GetOrigins() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLORIGINS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function GetCollectionMethods() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLCOLLECTIONMETHODS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllDestinations() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLDESTINATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function deleteRegistration(id) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_DELETEREGISTRATION);
    url += `?id=${id}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function saveRegistration(object) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(object)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEREGISTRATION);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
